"use strict";

import api from "vwa/api";
import getContext from "vwa/getContext";

export default async function login(token, username, password) {
	
	let requestData;
	
	if (token) {
		requestData = {
			token: token,
			clientDevice: (getContext() == "chromeapp") ? "Seagal" : (window.navigator.userAgent || "unknown")
		};
	}
	else {
		var md5 = require('md5');
		requestData = {
			username: username,
			password: md5(password),
			clientDeviceId: "unknown",
			clientType: "WEB",
			clientDevice: (getContext() == "chromeapp") ? "Seagal" : (window.navigator.userAgent || "unknown")
		};
	}
	
	return await api[token ? "put" : "post"]('users/login', requestData);
}


// WEBPACK FOOTER //
// ./src/api/login.js